/**
 * Limitador de ventana deslizante: no más de `max` usos en los últimos `ventanaMs`. El back deja
 * pasar 30 peticiones por minuto por endpoint y por IP; las fotos de los productos comparten un
 * solo endpoint, así que se piden con un tope propio por debajo de ese límite.
 */
export class LimitadorVentana {
  private marcas: number[] = [];

  constructor(
    private readonly max: number,
    private readonly ventanaMs: number,
    private readonly ahora: () => number = () => Date.now(),
  ) {}

  /** Milisegundos que faltan para poder usar uno más; 0 si ya se puede. */
  espera(): number {
    const t = this.ahora();
    this.marcas = this.marcas.filter(m => t - m < this.ventanaMs);
    if (this.marcas.length < this.max) return 0;
    return Math.max(0, this.marcas[0] + this.ventanaMs - t);
  }

  registrar(): void {
    this.marcas.push(this.ahora());
  }
}
